import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';
import ContactAppResource from './ContactAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PropertyAppResource from './PropertyAppResource';
import PropertyInstanceAppResource from './PropertyInstanceAppResource';
import UserAppResource from './UserAppResource';
import AgentContactAppResource from "./AgentContactAppResource";

class EmailAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Email';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'emails';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'email',
            'users',
            'organizations',
            'properties',
            'propertyInstances',
            'businessProfiles',
            'contacts',
            'agentContacts',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            users: UserAppResource,
            organizations: OrganizationAppResource,
            properties: PropertyAppResource,
            propertyInstances: PropertyInstanceAppResource,
            businessProfiles: BusinessProfileAppResource,
            contacts: ContactAppResource,
            agentContacts: AgentContactAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            email: {
                type: 'string',
                presence: true,
                email: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            meta: {},
        };
    }

}

export default EmailAppResource;
